<!--
 * @Descripttion: 数据加工控件
 * @Author: zenghua.wang
 * @Date: 2021-11-01 09:27:25
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-04 17:26:44
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    center
    width="90%"
  >
    <el-form
      ref="dataForm"
      size="small"
      label-width="130px"
      label-position="left"
      label-suffix=":"
      :model="data.apisDataProcessingCtls"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="名称"
            prop="ctlsName"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisDataProcessingCtls.ctlsName"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="主变量"
            prop="variableInData"
          >
            <el-select
              v-model="data.apisDataProcessingCtls.variableInData"
              size="small"
              style="width:100%"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in cellList"
                :key="item.title"
                :label="`${item.title} (${item.name})`"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="data-panel">
      <!-- <h5 class="data-panel-title">键值配置</h5> -->
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        style="margin-bottom: 20px"
        @click="addDataProcess"
      >新增</el-button>
      <el-table
        v-loading="loading"
        size="small"
        tooltip-effect="dark"
        style="width: 100%"
        border
        fit
        id="dragSortdata"
        row-key="id"
        :data="data.apisDataProcessingCtlsDetailList"
      >
        <el-table-column
          label="加工方式"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.funcType"
              size="small"
              clearable
              filterable
              placeholder="请选择"
              @change="changeType($event, scope.$index)"
              @visible-change="fixZoom"
            >
              <el-option
                v-for="item in functionTyle"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="方法"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.functions"
              size="small"
              clearable
              filterable
              placeholder="请选择"
              @change="changeFunction($event, scope.row)"
              @visible-change="fixZoom"
            >
              <el-option
                v-for="item in scope.row.functionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="参数1"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              :placeholder="scope.row.tips.param1 || '请输入'"
              v-model="scope.row.param1"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="参数2"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              :placeholder="scope.row.tips.param2 || '请输入'"
              v-model="scope.row.param2"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="参数3"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              :placeholder="scope.row.tips.param3 || '请输入'"
              v-model="scope.row.param3"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="参数4"
          align="center"
          min-width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              :placeholder="scope.row.tips.param4 || '请输入'"
              v-model="scope.row.param4"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="新变量名"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.variableNewData"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="80"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="deleteDataProcess(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import mysortable from 'sortablejs'
import { createId, isEmpty } from '@/apisManage/utils'
export default {
  name: 'ApisConst',
  components: {},
  inject: ['main'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '数据加工'
    },
    tenantId: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    change: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      visible: this.show,
      rules: {
        ctlsName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        variableInData: [
          { required: true, message: '请输入新变量名', trigger: 'blur' }
        ]
      },
      functionTyle: [],
      cellList: []
    }
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        // 变量
        let cells = this.main.editor.parseXml2Json('vertex')
        this.cellList = cells.filter((item) => {
          return (item.value === 'table' || item.value === 'http') && item.name
        })
        this.cellList.push({title:'apis内部变量',name:'_Apis'})
        this.cellList.push({title:'全局请求参数',name:'req'})
        // 赋值
        this.data.apisDataProcessingCtls.id = this.main.selectCell.id
        this.loadOption()
        // 拖拽排序
        this.$nextTick(() => {
          this.onDragSort()
        })
      }
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  methods: {
    loadOption() {
      this.loading = true
      this.functionTyle = []
      this.$http
        .get('/pub/dm-const/listByCataCode?cataCode=APIS_DATA_PROCESSING_TYPE')
        .then((res) => {
          if (res.code === 200) {
            this.functionTyle = res.data
          }
        })
        .catch((err) => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadFunction(value, index) {
      this.loading = true
      try {
        let res = await this.$http.get(
          `/pub/dm-const/listSubVoByParentCataCodeItemCode?cataCode=APIS_DATA_PROCESSING_TYPE&&itemCode=${value}`
        )
        if (res.code === 200) {
          this.data.apisDataProcessingCtlsDetailList[index].functionList =
            res.data
          // this.$set(this.data.apisDataProcessingCtlsDetailList[index], 'functionList', res.data || [])
        }
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
      }
    },
    changeType(type, index) {
      this.loadFunction(type, index)
    },
    changeFunction(val, row) {
      row.funcName = val
      let tips = window.Config.API_DATAPROCESS_TIPS[row.funcType + '_' + row.funcName] || {}
      row.tips = tips
    },
    addDataProcess() {
      this.data.apisDataProcessingCtlsDetailList =
        this.data.apisDataProcessingCtlsDetailList.filter((item) => {
          return item.funcType || item.functions || item.param1
        })
      let len = this.data.apisDataProcessingCtlsDetailList.length
      this.data.apisDataProcessingCtlsDetailList.push({
        id: createId(),
        dataProcessingCtlsId:
          this.data.apisDataProcessingCtls.id || createId('data'),
        tenantId: this.tenantId,
        funcType: null,
        functions: null,
        funcName: null,
        param1: null,
        param2: null,
        param3: null,
        param4: null,
        variableNewData: null,
        sortting: len + 1,
        functionList: [],
        tips: {
          param1: null,
          param2: null,
          param3: null,
          param4: null
        }
      })
    },
    deleteDataProcess(index) {
      this.data.apisDataProcessingCtlsDetailList.splice(index, 1)
    },
    onSubmit() {
      this.$refs.dataForm.validate((bool) => {
        if (bool) {
          this.data.apisDataProcessingCtls.createTime =
            this.main.selectCell.createTime
          if (!isEmpty(this.data.apisDataProcessingCtlsDetailList)) {
            let bool2 = this.data.apisDataProcessingCtlsDetailList.every(
              (item) => {
                return item.funcType && item.functions
              }
            )
            if (!bool2) {
              this.$message.error('每行的加工方式、方法为必填字段！')
              return
            }
          }
          this.$emit('change', 'data', this.data)
          this.visible = false
        }
      })
    },
    // 行拖拽排序
    onDragSort() {
      let self = this
      let tbody = document.querySelector('#dragSortdata tbody')
      if (tbody) {
        // 修复zoom
        if (window.navigator.userAgent.indexOf('Chrome') > 0) {
          tbody.style.zoom = 1 / window.scale || 1
        }
        // sortable
        this.sortable = mysortable.create(tbody, {
          disabled: false,
          animation: 200,
          group: 'dataProcess',
          sort: true,
          draggable: '.el-table__row',
          direction: 'vertical',
          onEnd: (e) => {
            let list = self.data.apisDataProcessingCtlsDetailList
            let item = list.splice(e.oldIndex, 1)[0]
            list.splice(e.newIndex, 0, item)
            // 选择字段排序处理
            list.forEach((el, index) => {
              el.sortting = index + 1
            })
            this.$nextTick(() => {
              self.data.apisDataProcessingCtlsDetailList = list
            })
          }
        })
      }
    },
    // 修复zoom导致的bug
    fixZoom(visible) {
      if (window.navigator.userAgent.indexOf('Chrome') > 0) {
        let select = document.querySelectorAll('.el-select-dropdown')
        if (visible) {
          select.forEach((item) => {
            item.style.zoom = 1 / window.scale || 1
          })
        } else {
          setTimeout(() => {
            select.forEach((item) => {
              item.style.zoom = 'inherit'
            })
          }, 500)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.data {
  &-panel {
    padding: 15px 0;

    &-title {
      text-align: center;
      font-size: 16px;
      color: #3b9cd9;
    }
  }
}
</style>
